function loadJQueryForReviewList() {
  var waitForLoad = function () {
    if (typeof jQuery != "undefined") {
      $('.ReviewList').slick({
        slidesToShow: 3,
        variableWidth: false,
        centerMode: true,
        centerPadding: '0',
        dots: true,
        focusOnSelect: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="u-visually-hidden">Previous slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="u-visually-hidden">Next slide</span><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        draggable: false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 885,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    } else {
      console.log("jquery not loaded..");
      window.setTimeout(waitForLoad, 500);
    }
  };
  window.setTimeout(waitForLoad, 500);
}

loadJQueryForReviewList();